import moment from "moment";
export const dateTime = (date) => {
    if (moment(date).isValid()) {
        return moment(date).format("DD/MM/YY, h:mma");
    } else {
        return "-";
    }
}


export const justDate = (date) => {
    if (moment(date).isValid()) {
        return moment(date).format("DD/MM/YY");
    } else {
        return "-";
    }
}

export const fullDate =  (date) => {
    if (moment(date).isValid()) {
        return moment(date).format("DD/MM/YYYY");
    } else {
        return "-";
    }
}


export const isRecent30Days = (updatedAt) => {
    return moment().diff(moment(updatedAt), "days") <= 30;
};

export const isRecent60Seconds = (updatedAt) => {
    return moment().diff(moment(updatedAt), "seconds") <= 60;
};
